/**
 * Wrapper for UUID generation using `uuid` library.
 *
 * Reason for creating this file:
 * The direct use of `import { v4 as uuidv4 } from 'uuid'` was causing issues
 * in the project due to a potential conflict with the current Gasket version
 * or its underlying dependencies. By wrapping the `uuid` library in this file,
 * we aim to isolate the issue and standardize its usage across the project.
 *
 * TODO:
 * When upgrading the Gasket version or making changes to the build process,
 * revisit this file to verify if the direct import issue has been resolved.
 * If the conflict no longer exists, consider removing this wrapper and using
 * `import { v4 as uuidv4 } from 'uuid'` directly in files where UUIDs are needed.
 */

const { v4: uuidv4 } = require('uuid');

export const uuid = uuidv4;
